<template>
  <div class="pedidos-container" :class="{ 'no-header': hideHeaderControls }">
    <modal_pdf_pedido ref="modal_pdf_pedido"/>
    <modal-boleto ref="modal_boletos"/>
    <modal-nf ref="modalNf"/>
    <modal-documentos-n-f ref="modalDocsNf"/>

    <b-overlay :show="isLoading" variant="light" opacity="0.85" blur="2px">
      <div class="table-header" v-if="!hideHeaderControls">
        <div class="table-info">
          <feather-icon icon="PackageIcon" size="16" class="info-icon" />
          <span class="record-count">{{ totalRecords }} pedido{{ totalRecords !== 1 ? 's' : '' }}</span>
        </div>
        <div class="table-controls">
          <button class="export-btn" :disabled="isExporting" @click="exportData" title="Exportar pedidos exibidos (CSV / Excel)">
            <feather-icon icon="DownloadIcon" size="14" />
            <span>{{ isExporting ? 'Exportando...' : 'Exportar' }}</span>
          </button>
          <label class="per-page-label">Exibir:</label>
          <select
            class="per-page-select"
            :value="getMeta.pageSize"
            @change="pageSelect($event)"
          >
            <option :value="10">10</option>
            <option :value="20">20</option>
            <option :value="50">50</option>
            <option :value="100">100</option>
          </select>
        </div>
      </div>

      <div class="table-wrapper">
        <table class="data-table" v-if="getPedidoVendas.length > 0">
          <thead>
            <tr>
              <th style="width: 1%; white-space: nowrap">PRÉ PEDIDO</th>
              <th>PEDIDO ERP</th>
              <th>CLIENTE</th>
              <th v-if="!ocultarInfoComercial">REPRESENTANTE</th>
              <th class="text-center">EMISSÃO</th>
              <th v-if="$store.getters['preferencias/exibirDataPrevistaEntrega'] !== false" class="text-center">PREV. ENTREGA</th>
              <th class="text-right">VALOR TOTAL</th>
              <th class="text-center">SITUAÇÃO</th>
              <th class="text-center">AÇÕES</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in getPedidoVendas" :key="item._listingKey" :id="pedidoRowId(item)" tabindex="-1">
              <td class="font-mono">{{ item._referenciaPrincipal }}</td>
              <td class="font-mono">{{ item.pedidoNumeroIntegracao || '-' }}</td>
              <td>
                <div class="client-info">
                  <span v-if="!isClienteAtivo" class="client-id">{{ item.clienteIdERP }}</span>
                  <span class="client-name">{{ item.clienteRazaoSocial }}</span>
                </div>
              </td>
              <td v-if="!ocultarInfoComercial">
                <div class="rep-info" v-if="item.representanteId">
                  <span class="rep-id">{{ item.representanteId }}</span>
                  <span class="rep-name">{{ item.representantenome }}</span>
                </div>
                <span v-else class="text-muted">-</span>
              </td>
              <td class="text-center">{{ pedidoDataExibicao(item.pedidoData) }}</td>
              <td v-if="$store.getters['preferencias/exibirDataPrevistaEntrega'] !== false" class="text-center">{{ pedidoDataExibicao(item.pedidoDataEntregaPrevista) }}</td>
              <td class="text-right font-mono" :title="complementoValorBo(item)">
                {{ formatValorComImpostos(item) }}
                <small v-if="motivoValorBo(item)" class="bo-price-reason text-muted">{{ motivoValorBo(item) }}</small>
              </td>
              <td class="text-center">
                {{ situacaoExibida(item) }}
              </td>
              <td class="text-center">
                <div class="action-buttons">
                  <button
                    class="action-btn action-btn-view"
                    @click="detalhePedido(item)"
                    :title="item._isBackorder ? 'Ver atendimento desta BO' : 'Ver Detalhes'"
                  >
                    <feather-icon icon="EyeIcon" size="16" />
                  </button>
                  <button
                    class="action-btn action-btn-pdf"
                    @click="showModalPdf(item)"
                    title="Gerar PDF"
                  >
                    <feather-icon icon="FileTextIcon" size="16" />
                  </button>
                  <exportar-pedido-xlsx compacto :pedido-id="item.pedidoId"
                    :referencia-bo="item._isBackorder ? item.pedidoNumeroIntegracao : ''" />
                  <button
                    v-if="!item._isBackorder"
                    class="action-btn action-btn-repetir"
                    @click="repetirPedido(item)"
                    :disabled="repetindoPedido"
                    title="Repetir Pedido"
                  >
                    <span v-if="repetindoPedido" class="spinner-border spinner-border-sm" role="status" aria-label="Repetindo pedido" />
                    <feather-icon v-else icon="RepeatIcon" size="16" />
                  </button>
                  <!-- <button
                    v-if="item.notaFiscalNumero"
                    class="action-btn action-btn-boleto"
                    @click="exibirModalBoleto(item)"
                    title="Ver Boleto"
                  >
                    <feather-icon icon="CreditCardIcon" size="16" />
                  </button> -->
                  <button
                    v-if="item.NotaFiscal && item.NotaFiscal.length"
                    class="action-btn action-btn-boleto"
                    @click="copiarNF(item.NotaFiscal)"
                    title="Copiar Nota Fiscal"
                  >
                    <feather-icon icon="FileIcon" size="16" />
                  </button>
                  <button
                    class="action-btn action-btn-view"
                    @click="abrirDocumentosNF(item)"
                    title="Documentos da NF (DANFE)"
                  >
                    <feather-icon icon="DownloadIcon" size="16" />
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-else class="empty-state">
          <div class="empty-icon">
            <feather-icon icon="InboxIcon" size="48" />
          </div>
          <p class="empty-text">Nenhum pedido encontrado</p>
          <p class="empty-subtext">Ajuste os filtros para ver resultados</p>
        </div>
      </div>

      <div class="table-footer" v-if="getPedidoVendas.length > 0">
        <div class="pagination-info">
          Mostrando {{ startRecord }} a {{ endRecord }} de {{ totalRecords }} pedidos principais
        </div>
        <div class="pagination-controls">
          <button
            class="page-btn"
            :disabled="getMeta.page <= 1"
            @click="goToPage(1)"
            title="Primeira página"
          >
            <feather-icon icon="ChevronsLeftIcon" size="16" />
          </button>
          <button
            class="page-btn"
            :disabled="getMeta.page <= 1"
            @click="goToPage(getMeta.page - 1)"
            title="Página anterior"
          >
            <feather-icon icon="ChevronLeftIcon" size="16" />
          </button>

          <button
            v-for="page in visiblePages"
            :key="page"
            class="page-btn page-number"
            :class="{ active: page === getMeta.page }"
            @click="goToPage(page)"
          >
            {{ page }}
          </button>

          <button
            class="page-btn"
            :disabled="getMeta.page >= totalPages"
            @click="goToPage(getMeta.page + 1)"
            title="Próxima página"
          >
            <feather-icon icon="ChevronRightIcon" size="16" />
          </button>
          <button
            class="page-btn"
            :disabled="getMeta.page >= totalPages"
            @click="goToPage(totalPages)"
            title="Última página"
          >
            <feather-icon icon="ChevronsRightIcon" size="16" />
          </button>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { valorBoExibido, complementoValorBo, motivoValorBo, pedidoListingRows, pedidoRowId, pedidoCsv } from '@/utils/pedidoListingRows';
import Modal_pdf_pedido from '@/views/app/operacoes/pedidosVendas/modal/modal_pdf_pedido.vue';
import ExportarPedidoXlsx from '@/components/pedidos/ExportarPedidoXlsx.vue';
import ModalBoleto from '@/views/app/operacoes/pedidosVendas/modal/modalBoleto.vue';
import { formtPriceBr } from '@core/utils/filter';
import modalNf from './modal/modalNF.vue';
import ModalDocumentosNF from './modal/modalDocumentosNF.vue';
import StatusBadge from './components/StatusBadge.vue';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';
import { IMAGEM_PADRAO } from '@/utils/imagemUrl';
import EsMarcaClient from '@/api/SistemaDKP/sls-marca.client';
import { ocultarInfoComercialCliente, isPerfilClienteAtivo, isPerfilRepresentanteAtivo } from '@/libs/perfilCliente';
import SLSEstoqueService from '@/services/SistemaDKP/SLSEstoque.service';
import pedidoDataExibicao from '@/utils/pedidoDataExibicao';
import pedidoSituacaoAtual from '@/utils/pedidoSituacaoAtual';
import { simularPrecoAtualCarrinho, aplicarPrecoAtualCarrinho } from '@/utils/impostoSimulador';
import { confirmarInfoPedido } from '@/utils/solicitarInfoPedido';

export default {
  components: {
    ExportarPedidoXlsx,
    ModalBoleto,
    Modal_pdf_pedido,
    modalNf,
    ModalDocumentosNF,
    StatusBadge,
  },
  props: {
    hideHeaderControls: {
      type: Boolean,
      default: false,
    },
  },
  filters: {
    formtPriceBr,
  },
  data() {
    return { isExporting: false, repetindoPedido: false };
  },
  computed: {
    ...mapGetters({
      pedidosPrincipais: 'SLS_PedidosVendas/getPedidoVendas',
      getMeta: 'SLS_PedidosVendas/getMeta',
      getFilters: 'SLS_PedidosVendas/getFilters',
    }),
    getPedidoVendas() {
      return pedidoListingRows(this.pedidosPrincipais, 'operacoes', this.getFilters?.somenteBackorders, this.getFilters?.status);
    },
    // Preferência CLIENTE_OCULTAR_INFO_COMERCIAL: esconde (só visualmente)
    // a coluna Representante p/ perfil Cliente.
    ocultarInfoComercial() {
      return ocultarInfoComercialCliente(this.$store);
    },
    // Perfil cliente NUNCA vê o próprio código ERP (tela e export).
    isClienteAtivo() {
      return isPerfilClienteAtivo();
    },
    isLoading() {
      return this.$store.getters['SLS_PedidosVendas/getIsLoading'];
    },
    totalRecords() {
      return this.getMeta?.total || 0;
    },
    totalPages() {
      return Math.ceil(this.totalRecords / (this.getMeta?.pageSize || 10));
    },
    startRecord() {
      if (this.totalRecords === 0) return 0;
      return ((this.getMeta?.page || 1) - 1) * (this.getMeta?.pageSize || 10) + 1;
    },
    endRecord() {
      const end = (this.getMeta?.page || 1) * (this.getMeta?.pageSize || 10);
      return Math.min(end, this.totalRecords);
    },
    visiblePages() {
      const pages = [];
      const current = this.getMeta?.page || 1;
      const total = this.totalPages;

      let start = Math.max(1, current - 2);
      let end = Math.min(total, current + 2);

      if (end - start < 4) {
        if (start === 1) {
          end = Math.min(total, start + 4);
        } else if (end === total) {
          start = Math.max(1, end - 4);
        }
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      return pages;
    },
  },
  methods: {
    pedidoDataExibicao,
    pedidoRowId,
    async exportData() {
      // Exporta um CSV (abre no Excel) com TODOS os pedidos do filtro atual
      // (não só a página exibida), com as mesmas colunas da tabela.
      if (this.isExporting) return;
      this.isExporting = true;
      this.$emit('exporting-change', true);
      try {
        const boMode = this.getFilters?.somenteBackorders;
        const selectedStatus = this.getFilters?.status;
        const pedidos = await this.$store.dispatch('SLS_PedidosVendas/buscarPedidosVendasExportacao');
        if (!Array.isArray(pedidos)) throw new Error('Resposta inválida ao exportar os pedidos.');
        const rows = pedidoListingRows(pedidos, 'operacoes', boMode, selectedStatus);
        const cols = [
          { label: 'Pré Pedido', get: (i) => i._referenciaPrincipal },
          { label: 'Pedido ERP', get: (i) => i.pedidoNumeroIntegracao },
          ...(this.isClienteAtivo ? [] : [
            { label: 'Cliente', get: (i) => i.clienteIdERP },
          ]),
          { label: 'Razão Social', get: (i) => i.clienteRazaoSocial },
          ...(this.ocultarInfoComercial ? [] : [
            { label: 'Representante', get: (i) => (i.representanteId ? `${i.representanteId} - ${i.representantenome || ''}`.trim() : '') },
          ]),
          { label: 'Emissão', get: (i) => pedidoDataExibicao(i.pedidoData) },
          ...(this.$store.getters['preferencias/exibirDataPrevistaEntrega'] !== false
            ? [{ label: 'Prev. Entrega', get: (i) => pedidoDataExibicao(i.pedidoDataEntregaPrevista) }] : []),
          { label: 'Valor Total', get: (i) => this.formatValorComImpostos(i) },
          { label: 'Complemento Valor BO', get: (i) => complementoValorBo(i) },
          { label: 'Situação', get: (i) => this.situacaoExibida(i) },
        ];
        // BOM p/ o Excel reconhecer acentuação UTF-8
        const blob = new Blob([pedidoCsv(rows, cols)], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        const hoje = new Date().toISOString().slice(0, 10);
        a.href = url;
        a.download = `pedidos_${hoje}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      } catch (e) {
        console.error('[Pedidos] erro ao exportar', e);
        this.$bvToast.toast('Não foi possível exportar os pedidos.', { title: 'Exportar', variant: 'danger', solid: true });
      } finally {
        this.isExporting = false;
        this.$emit('exporting-change', false);
      }
    },
    // Coluna única de situação: estados do fluxo interno (aprovação/cancelamento)
    // prevalecem; nos demais casos, mostra a situação do ERP (mais informativa).
    situacaoExibida(item) {
      if (item._isBackorder) return item._situacaoBo;
      return pedidoSituacaoAtual(item);
    },
    formatValorComImpostos(item) {
      if (item._isBackorder) return valorBoExibido(item);
      if (item.pedidototalcomimpostos !== null && item.pedidototalcomimpostos !== undefined && item.pedidototalcomimpostos !== '') {
        const valor = Number(item.pedidototalcomimpostos);
        return Number.isNaN(valor) ? item.pedidototalcomimpostos : this.formatCurrency(valor);
      }
      return item.pedidoValorTotal || 'R$ 0,00';
    },
    formatCurrency(value) {
      if (value === null || value === undefined) return 'R$ 0,00';
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(value);
    },
    complementoValorBo,
    motivoValorBo,
    async goToPage(pageNum) {
      const page = parseInt(pageNum);
      if (page < 1 || page > this.totalPages || page === this.getMeta.page) return;
      await this.$emit('paginateFilters', { page });
    },
    async pageSelect(event) {
      const pageSize = parseInt(event.target.value);
      await this.$emit('paginateFilters', { pageSize, page: 1 });
    },
    copiarTextoFallback(texto) {
      if (
        typeof document === 'undefined'
        || !document.body
        || typeof document.createElement !== 'function'
      ) {
        return false;
      }

      const elementoAtivo = document.activeElement;
      let textarea = null;
      let copiado = false;

      try {
        textarea = document.createElement('textarea');
        textarea.value = texto;
        textarea.setAttribute('readonly', '');
        textarea.setAttribute('aria-hidden', 'true');
        textarea.style.position = 'fixed';
        textarea.style.top = '0';
        textarea.style.left = '-9999px';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        if (typeof textarea.focus === 'function') textarea.focus();
        if (typeof textarea.select === 'function') textarea.select();
        if (typeof textarea.setSelectionRange === 'function') {
          textarea.setSelectionRange(0, textarea.value.length);
        }
        copiado = typeof document.execCommand === 'function'
          && document.execCommand('copy') === true;
      } catch (err) {
        copiado = false;
      } finally {
        if (textarea) {
          try {
            if (textarea.parentNode && typeof textarea.parentNode.removeChild === 'function') {
              textarea.parentNode.removeChild(textarea);
            } else if (typeof document.body.removeChild === 'function') {
              document.body.removeChild(textarea);
            }
          } catch (err) {
            // A limpeza não pode impedir a restauração do foco original.
          }
        }
        if (elementoAtivo && typeof elementoAtivo.focus === 'function') {
          try {
            elementoAtivo.focus();
          } catch (err) {
            // O foco pode ter sido removido durante a tentativa de cópia.
          }
        }
      }

      return copiado === true;
    },
    async copiarNF(notaFiscal) {
      const texto = Array.isArray(notaFiscal)
        ? notaFiscal.map(nf =>
            `Série: ${nf.notafiscalserie}\nNúmero: ${nf.notafiscalnumero}\nEmissão: ${nf.notafiscaldtemissao}\nConfirmação: ${nf.notafiscaldtconfirma}\nPrevisão de entrega: ${nf.notafiscaldtpreventrega}\nAtualização ACR: ${nf.notafiscaldtatualizaacr}\nData de saída de entrega: ${nf.notafiscaldtsaidaentrega}\nValor total: ${nf.notafiscalvalortotal}`
          ).join('\n\n')
        : String(notaFiscal);
      let copiado = false;

      try {
        if (
          typeof navigator !== 'undefined'
          && navigator.clipboard
          && typeof navigator.clipboard.writeText === 'function'
        ) {
          await navigator.clipboard.writeText(texto);
          copiado = true;
        }
      } catch (err) {
        copiado = false;
      }

      if (!copiado) {
        try {
          copiado = this.copiarTextoFallback(texto) === true;
        } catch (err) {
          copiado = false;
        }
      }

      this.$toast({
        component: ToastificationContent,
        props: copiado
          ? {
              title: 'Sucesso',
              text: 'Nota Fiscal copiada para área de transferência!',
              icon: 'CheckCircleIcon',
              variant: 'success',
            }
          : {
              title: 'Erro',
              text: 'Falha ao copiar Nota Fiscal. Tente novamente.',
              icon: 'XCircleIcon',
              variant: 'danger',
            },
      });

      return copiado === true;
    },
    abrirDocumentosNF(item) {
      this.$refs.modalDocsNf.show(item.pedidoId, item._etapaFiscal || 'original');
    },
    async exibirModalBoleto(boleto) {
      this.$refs.modal_boletos.showModalBoleto({
        clienteId: boleto.clienteId,
        pedidoId: boleto.pedidoId,
      });
    },
    async detalhePedido(data) {
      await this.$router.push({
        name: 'pedidos-vendas-detalhes',
        params: { tenantSlug: this.$route.params.tenantSlug, pedidoid: data.pedidoId, clienteid: data.clienteId },
        ...(data._isBackorder ? { query: { bo: data.pedidoNumeroIntegracao } } : {}),
      });
    },
    async repetirPedido(data) {
      if (this._repetindoPedido) return;
      if (!confirmarInfoPedido(this)) return;
      this._repetindoPedido = true;
      this.repetindoPedido = true;
      try {
        // A origem fornece somente produtos/quantidades; o destino é o InfoPedido.
        const currentForm = this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'] || {};
        const contextoAnterior = JSON.stringify(currentForm);
        const novaForm = JSON.parse(contextoAnterior);
        const pedidoAnterior = this.$store.getters['PedidosStore/getPedido'];
        await this.$store.dispatch('SLS_PedidosVendas/listarCapaPedido', data.pedidoId);
        await this.$store.dispatch('SLS_PedidosVendas/retornaItensPedido', data.pedidoId);

        const capa = this.$store.getters['SLS_PedidosVendas/getCapaPedido'] || {};
        const itens = this.$store.getters['SLS_PedidosVendas/getItensPedido'] || [];

        if (!capa.clienteid || !Array.isArray(itens) || itens.length === 0) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Não foi possível repetir o pedido',
              text: 'Não foi possível carregar os itens do pedido selecionado.',
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          });
          return;
        }

        // Achata os itens do pedido (item -> itens[]) para o formato do carrinho da home (PedidosStore)
        const cartItens = [];
        let seq = 0;
        itens.forEach((item) => {
          const subItens = Array.isArray(item.itens) ? item.itens : [];
          subItens.forEach((sub) => {
            const quantidade = parseInt(sub.pedidoItemQuantidade, 10) || 0;
            seq += 10;
            cartItens.push({
              index: cartItens.length + 1,
              cod_marca: sub.codMarca,
              familia_comercial_id: sub.familiaComercialId || item.referencia,
              familia_comercial_descricao: item.referencia,
              cdn_cor: sub.cdncor,
              cdn_tamanho: sub.cdn_tamanho,
              des_tamanho: sub.desc_tamanho,
              des_cor: sub.des_cor,
              item_id: sub.itemId,
              item_descricao: sub.item_descricao || item.referencia,
              item_imagem: sub.item_img_principal || sub.imagem || item.item_img_principal || IMAGEM_PADRAO,
              pedido_item_seq: seq,
              pic_id: 0,
              marca: sub.marca,
              embalagem: sub.embalagem,
              cdn_embalag: sub.cdn_embalagem,
              pedido_item_quantidade: quantidade,
              categoria_tipo_pedido: novaForm.tipoPedidoCliente?.tipopedidoid,
              cliente: novaForm.cliente?.clientenomeabreviado,
              itemMultiplo: Number(sub.itemMultiplo) > 1 ? Number(sub.itemMultiplo) : null,
            });
          });
        });

        if (cartItens.length === 0) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Não foi possível repetir o pedido',
              text: 'O pedido selecionado não possui itens válidos.',
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          });
          return;
        }

        // Prepare todas as linhas antes de tocar no pedido atual. Uma falha em
        // qualquer SKU mantém carrinho e contexto anteriores intactos.
        if (!isPerfilClienteAtivo()
          && (this.$store.getters['preferencias/bloquearVendaSemEstoque'] || isPerfilRepresentanteAtivo())) {
          const quantidades = {};
          cartItens.forEach((item) => {
            quantidades[item.item_id] = (quantidades[item.item_id] || 0) + Number(item.pedido_item_quantidade);
          });
          const saldos = await new SLSEstoqueService().consultarEstoque(Object.keys(quantidades), {
            fresh: true,
            tipoPedidoId: novaForm.tipoPedidoCliente?.tipopedidoid || novaForm.tipoPedido?.tipopedidoid,
          });
          Object.keys(quantidades).forEach((id) => {
            const saldo = saldos?.[id]?.quantidade;
            if (saldo === 'INF') return;
            if (saldo == null || !Number.isFinite(Number(saldo))) {
              throw new Error(`Não foi possível confirmar o estoque do item ${id}. O carrinho foi preservado.`);
            }
            if (quantidades[id] > Number(saldo)) {
              throw new Error(`Estoque insuficiente para o item ${id}: solicitado ${quantidades[id]}, disponível ${saldo}. O carrinho foi preservado.`);
            }
          });
        }
        const calculados = await Promise.all(cartItens.map(async (item) => {
          const calculo = await simularPrecoAtualCarrinho(novaForm, item.item_id);
          return aplicarPrecoAtualCarrinho(item, calculo);
        }));
        if (JSON.stringify(this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'] || {}) !== contextoAnterior
          || this.$store.getters['PedidosStore/getPedido'] !== pedidoAnterior) {
          throw new Error('O contexto do pedido mudou durante o cálculo. Repita a operação com o cliente e a tabela atuais.');
        }
        // Fotos são best-effort e não podem atrasar a adoção do preço verificado.
        await this.hidratarImagensCarrinho(calculados);
        if (JSON.stringify(this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'] || {}) !== contextoAnterior
          || this.$store.getters['PedidosStore/getPedido'] !== pedidoAnterior) {
          throw new Error('O contexto do pedido mudou durante a cópia. Tente novamente.');
        }

        // Carrinho da home (PedidosStore): capa + itens
        const pedidoAtual = this.$store.getters['PedidosStore/getPedido'] || {};
        const totalPedido = calculados.reduce((acc, i) => acc + Number(i.valor_total || 0), 0);
        const totalItens = calculados.reduce((acc, i) => acc + Number(i.pedido_item_quantidade || 0), 0);
        this.$store.commit('PedidosStore/SET_PEDIDO', {
          ...pedidoAtual,
          clienteid: novaForm.cliente?.clienteid,
          representanteid: novaForm.representante?.representanteid,
          estabelecimentoid: novaForm.estabelecimento?.estabelecimentoid,
          condicaopagamentoid: novaForm.condicaoPagamento?.condicaopagamentoid,
          tabelaprecoid: novaForm.tabelaPreco?.tabelapreco_id,
          tipopedidoid: novaForm.tipoPedidoCliente?.tipopedidoid,
          naturezaoperacaoid: novaForm.naturezaOperacao?.naturezaoperacaoid,
          canalvendaid: novaForm.canalVenda?.canal_venda_id || novaForm.cliente?.canalvendaid,
          pedidooccliente: novaForm.numeroPedidoOrderCompra,
          pedidoobservacoes: novaForm.observacao,
          pedidoprioridade: novaForm.prioridadesPedido,
          cod_priori: novaForm.prioridadesPedido,
          pedidoItens: calculados,
          pedidoTotal: totalPedido,
          pedidoTotalItens: totalItens,
        });

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Itens adicionados ao carrinho',
            text: 'Os produtos do pedido foram adicionados ao carrinho. Ajuste o que precisar antes de finalizar.',
            icon: 'CheckCircleIcon',
            variant: 'success',
          },
        });

        await this.$router.push({ name: 'app-carrinho-compra' });
      } catch (error) {
        console.error('Erro ao repetir pedido:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro ao repetir o pedido',
            text: error.message || 'Ocorreu um erro ao carregar o pedido selecionado.',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        });
      }
      finally {
        this._repetindoPedido = false;
        this.repetindoPedido = false;
      }
    },
    async hidratarImagensCarrinho(cartItens) {
      try {
        const pares = new Map();
        cartItens.forEach((ci) => {
          if (ci.cod_marca && ci.familia_comercial_id) {
            pares.set(`${ci.cod_marca}::${ci.familia_comercial_id}`, {
              cod_marca: ci.cod_marca,
              familia_comercial_id: ci.familia_comercial_id,
            });
          }
        });
        if (!pares.size) return;
        const client = new EsMarcaClient();
        const mapaImg = new Map();
        await Promise.all([...pares.values()].map(async (p) => {
          try {
            const resp = await client.listarImagensPorMarca(p.cod_marca, {
              familia_comercial_id: p.familia_comercial_id,
            });
            const data = Array.isArray(resp) ? resp : resp?.data || [];
            const full = data[0];
            const imgs = (full && full.imagens) || [];
            if (!imgs.length) return;
            const principal = imgs.find((i) => i.imagemPrincipal === 1) || imgs[0];
            if (principal && principal.caminho) {
              mapaImg.set(`${p.cod_marca}::${p.familia_comercial_id}`, principal.caminho);
            }
          } catch (e) {
            // best-effort: mantém a imagem padrão deste item
          }
        }));
        cartItens.forEach((ci) => {
          const caminho = mapaImg.get(`${ci.cod_marca}::${ci.familia_comercial_id}`);
          if (caminho) ci.item_imagem = caminho;
        });
      } catch (e) {
        console.error('Erro ao hidratar imagens do carrinho (repetir pedido):', e);
      }
    },
    showModalPdf(data) {
      this.$refs.modal_pdf_pedido.showModalPdf(data);
    },
  },
};
</script>

<style scoped>
.pedidos-container {
  padding: 0.75rem;
}

.pedidos-container.no-header {
  padding: 0;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0 0.75rem;
}

.table-info {
  display: flex;
  align-items: center;
  gap: 0.375rem;
}

.info-icon {
  color: var(--sf-accent);
}

.record-count {
  font-size: 0.8125rem;
  font-weight: 500;
  color: var(--sf-text-primary);
}

.table-controls {
  display: flex;
  align-items: center;
  gap: 0.375rem;
}

.per-page-label {
  font-size: 0.75rem;
  color: var(--sf-text-secondary);
  margin: 0;
}

.export-btn {
  display: inline-flex;
  align-items: center;
  gap: .35rem;
  padding: .35rem .8rem;
  font-size: .82rem;
  font-weight: 600;
  border-radius: 6px;
  background: var(--sf-surface-bg, #fff);
  border: 1px solid var(--sf-border-light, #e0e4f0);
  color: var(--primary, #2563eb);
  cursor: pointer;
  transition: all .2s ease;
  margin-right: .75rem;

  &:hover {
    background: var(--sf-accent-bg, rgba(37,99,235,.07));
    border-color: var(--primary, #2563eb);
  }
}

.per-page-select {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  border: 1px solid var(--sf-form-border);
  border-radius: 4px;
  background: var(--sf-form-bg);
  color: var(--sf-form-text);
  cursor: pointer;
}

.table-wrapper {
  overflow-x: auto;
}

.no-header .table-wrapper {
  border-radius: 0;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8125rem;
}

.data-table thead {
  background: var(--sf-table-header-bg);
}

.data-table th {
  padding: 0.5rem 0.75rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.6875rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--sf-table-header-text);
  border-bottom: 1px solid var(--sf-table-border);
  white-space: nowrap;
}

.data-table td {
  padding: 0.5rem 0.75rem;
  color: var(--sf-table-text);
  border-bottom: 1px solid var(--sf-table-border);
  vertical-align: middle;
}

.data-table tbody tr:hover {
  background: var(--sf-table-row-hover);
}

.data-table tbody tr:last-child td {
  border-bottom: none;
}

.text-center {
  text-align: center !important;
}

.text-right {
  text-align: right !important;
}

.font-mono {
  font-family: ui-monospace, SFMono-Regular, 'SF Mono', Menlo, Monaco, Consolas, monospace;
  font-size: 0.75rem;
}

.text-muted {
  color: var(--sf-text-muted);
}

.bo-price-reason {
  display: block;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.client-info,
.rep-info {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.client-id,
.rep-id {
  font-weight: 600;
  font-size: 0.75rem;
  color: var(--sf-text-primary);
}

.client-name,
.rep-name {
  font-size: 0.6875rem;
  color: var(--sf-text-secondary);
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 0.125rem;
}

.action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.action-btn-view {
  background: var(--sf-accent-bg, rgba(59, 130, 246, 0.1));
  color: var(--sf-accent, #3b82f6);
}

.action-btn-view:hover {
  background: var(--sf-accent-bg-hover, rgba(59, 130, 246, 0.2));
}

.action-btn-repetir {
  color: #9b51e0;
  background: rgba(155, 81, 224, 0.1);
}
.action-btn-repetir:hover {
  background: rgba(155, 81, 224, 0.2);
}
.action-btn-pdf {
  background: rgba(16, 185, 129, 0.1);
  color: #10b981;
}

.action-btn-pdf:hover {
  background: rgba(16, 185, 129, 0.2);
}

.action-btn-boleto {
  background: rgba(245, 158, 11, 0.1);
  color: #f59e0b;
}

.action-btn-boleto:hover {
  background: rgba(245, 158, 11, 0.2);
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  text-align: center;
}

.empty-icon {
  color: var(--text-muted, #94a3b8);
  margin-bottom: 1rem;
}

.empty-text {
  font-size: 1rem;
  font-weight: 500;
  color: var(--text-primary, #1e293b);
  margin: 0 0 0.25rem;
}

.empty-subtext {
  font-size: 0.875rem;
  color: var(--text-secondary, #64748b);
  margin: 0;
}

.table-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0.75rem;
  flex-wrap: wrap;
  gap: 0.5rem;
  border-top: 1px solid var(--sf-border-color);
  background: var(--sf-surface-bg);
}

.no-header .table-footer {
  border-radius: 0 0 8px 8px;
}

.pagination-info {
  font-size: 0.75rem;
  color: var(--sf-text-secondary);
}

.pagination-controls {
  display: flex;
  align-items: center;
  gap: 0.125rem;
}

.page-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
  padding: 0 0.375rem;
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--sf-text-secondary);
  background: transparent;
  border: 1px solid var(--sf-border-color);
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.page-btn:hover:not(:disabled) {
  background: var(--sf-dropdown-hover);
  color: var(--sf-accent);
  border-color: var(--sf-accent);
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-btn.active {
  background: var(--sf-accent);
  color: #ffffff;
  border-color: var(--sf-accent);
}

.page-number {
  font-weight: 500;
}

@media (max-width: 768px) {
  .pedidos-container {
    padding: 0.5rem;
  }

  .pedidos-container.no-header {
    padding: 0;
  }

  .table-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .table-footer {
    flex-direction: column;
    align-items: center;
  }

  .data-table th,
  .data-table td {
    padding: 0.375rem 0.5rem;
  }

  .client-name,
  .rep-name {
    max-width: 100px;
  }
}
</style>

<style>
/* Scrollbar da tabela no tema escuro (senão fica branca) */
.dark-layout .pedidos-container .table-wrapper,
.dark-layout .pedidos-container {
  scrollbar-color: #4b5563 #283046;
}
.dark-layout .pedidos-container ::-webkit-scrollbar,
.dark-layout .pedidos-container::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.dark-layout .pedidos-container ::-webkit-scrollbar-track,
.dark-layout .pedidos-container::-webkit-scrollbar-track {
  background: #283046;
}
.dark-layout .pedidos-container ::-webkit-scrollbar-thumb,
.dark-layout .pedidos-container::-webkit-scrollbar-thumb {
  background: #4b5563;
  border-radius: 4px;
}
</style>
